import { Button } from '@material-ui/core';
import React from 'react'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { setSecondDialog } from '../../../redux/actions/ui';
import { ExamenLaboratorioForm } from '../Forms/ExamenLaboratorioForm';
import { GeneralDialog, GeneralDialogActions, GeneralDialogContent, GeneralDialogTitle } from "./GeneralDialog";
export const LaboratoryExamDialog = () => {
    const handleClick = () => {}
    const dialog = useSelector(state => state.UI.secondDialog)
    const dispatch = useDispatch();
    const handleClose = () => {
        dispatch(setSecondDialog(false))
    }
    return (
        <GeneralDialog
            fullWidth
            maxWidth="md"
            onClose={handleClose}
            aria-labelledby="exam-lab-dialog-title"
            open={dialog}
        >
            <GeneralDialogTitle id="exam-lab-dialog-title">
                Exámen de Laboratorio
            </GeneralDialogTitle>
            <GeneralDialogContent>
                <ExamenLaboratorioForm/>
            </GeneralDialogContent>
            <GeneralDialogActions>
                <Button onClick={handleClick} color="primary" variant="contained" autoFocus>
                    Guardar
                </Button>
            </GeneralDialogActions>
        </GeneralDialog>
    )
}
